// @flow

import React, { type Node } from 'react';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useFieldMetadata } from '@tectonics/prs/form';
import { useUniqueId } from '@tectonics/hooks';
import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type Country } from '@tectonics/prs/country';
import { Empty } from '@tectonics/look-and-feel/commons/components';
import { SimpleTextErrorMessage } from '@tectonics/look-and-feel/commons/validation-error-message';
import { Field } from '../../../molecules';
import { Input, Label } from '../../../atoms';

export function FieldCustomerEmail(): Node {
  const inputId = useUniqueId();
  const labelMessage = 'E-mail';
  const [customerEmail, handleChange] = useUserInputAsTextField('customerEmail');
  const { mustShow, submitting, formHasBeenSent, validationError } = useFieldMetadata('customerEmail');

  if (!mustShow) {
    return <Empty />;
  }

  return (
    <Field
      showFloatingLabel={!!customerEmail}
      data-test-name="customer-email"
      label={<Label htmlFor={inputId}>{labelMessage}</Label>}
      hasError={validationError && formHasBeenSent}
      error={<SimpleTextErrorMessage getMessage={getMessage} validationError={validationError} />}
    >
      <Input
        placeholder={labelMessage}
        value={customerEmail}
        onChange={handleChange}
        readOnly={submitting}
        type="email"
        name="customer-email"
      />
    </Field>
  );
}

function getMessage(validationError: UserInputValidationError, country: Country): ?string {
  switch (validationError.id) {
    case 'empty':
      return 'Preencha seu email';
    default:
      return validationError.payload ? validationError.payload.message : 'Email inválido';
  }
}
